import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import { persistReducer, persistStore } from 'redux-persist';
import localforage from "localforage";
import { rootReducer } from "./modules";
import logger from "redux-logger";
import { SerializationUtil } from "@/util/helper/SerializationUtil.ts";
//todo LocalForage Configuration
localforage.config({
    driver: [
        localforage.INDEXEDDB,
        localforage.WEBSQL,
        localforage.LOCALSTORAGE,
    ],
    name: 'qoonity-portal',
    version: 1.0,
    storeName: 'qoonity-store',
    description: 'Storage for qoonity portal application'
});
//todo Simple persist config - persist everything except explicitly blacklisted items
const persistConfig = {
    key: 'root',
    storage: localforage,
    transforms: [SerializationUtil.createTransform()],
    blacklist: ['table'],
    debug: true,
};
const customMiddleware = (storeAPI) => (next) => (action) => {
    return next(action);
};
// Create Persisted Reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);
// Configure Store with serialization handling
export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    }).concat(customMiddleware, thunk, logger),
});
export const persistor = persistStore(store);
//todo Ensure application doesn't render until rehydration is complete
export const waitForRehydration = () => {
    return new Promise((resolve) => {
        const unsubscribe = store.subscribe(() => {
            const state = store.getState();
            if (state._persist?.rehydrated) {
                unsubscribe();
                resolve(true);
            }
        });
    });
};
